import { message } from '@widesk-ui/hooks/useMessage';

const copyToClipboard = (str: string, successMessage?: string) => {
	void navigator.clipboard.writeText(str);
	message.success(successMessage || 'Texte copié', 2);
	return str;
};

export default copyToClipboard;
